export default function initMenuDigital() {
    const locationStep = document.getElementById('location-step');
    const menuStep = document.getElementById('menu-step');

    if (!locationStep || !menuStep) return;

    const locationCards = document.querySelectorAll('.js-select-location');
    const btnBack = document.querySelector('.js-back-to-locations');
    const locationTitleLabel = document.getElementById('selected-location-label');
    const accordions = document.querySelectorAll('.accordion-item');
    const allDishCards = document.querySelectorAll('.dish-card');

    // Filtra platos y categorías según el local seleccionado.
    // Reglas:
    //   - data-locations vacío  → disponible en TODOS los locales (no se oculta)
    //   - data-locations="a,b"  → solo visible si el slug del local está en la lista
    function filterMenuByLocation(slug) {
        if (!slug) return;

        // 1. Mostrar/ocultar platos
        allDishCards.forEach(card => {
            const raw = (card.dataset.locations || '').trim();
            if (raw === '') {
                card.style.display = '';
                return;
            }
            const allowed = raw.split(',').map(s => s.trim()).filter(Boolean);
            card.style.display = allowed.includes(slug) ? '' : 'none';
        });

        // 2. Ocultar categorías (accordion-items) sin platos visibles
        accordions.forEach(acc => {
            const dishesInside = acc.querySelectorAll('.dish-card');
            let anyVisible = false;
            dishesInside.forEach(d => {
                if (d.style.display !== 'none') anyVisible = true;
            });
            acc.style.display = anyVisible ? '' : 'none';
        });
    }

    // Resetea filtros: muestra todos los platos y categorías de nuevo
    function resetMenuFilter() {
        allDishCards.forEach(card => { card.style.display = ''; });
        accordions.forEach(acc => { acc.style.display = ''; });
    }

    // Location Selection
    locationCards.forEach(card => {
        card.addEventListener('click', function (e) {
            e.preventDefault();

            const titleEl = this.querySelector('.location-card__title');
            const title = titleEl ? titleEl.innerText : this.innerText.trim();
            const slug = this.dataset.location || '';

            if (locationTitleLabel) locationTitleLabel.innerText = title;

            // Aplicar filtro de disponibilidad por local
            filterMenuByLocation(slug);

            if (locationStep && menuStep) {
                locationStep.classList.remove('active');
                menuStep.classList.add('active');
            }

            window.scrollTo({ top: 0, behavior: 'smooth' });

            // Cerrar menú móvil si estaba abierto
            const mobileMenu = document.querySelector('.cdr-mobile-menu');
            const toggleBtn = document.querySelector('.cdr-navbar__toggle');
            if (mobileMenu && mobileMenu.classList.contains('active')) {
                mobileMenu.classList.remove('active');
                if (toggleBtn) toggleBtn.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
    });

    // Going back to locations
    if (btnBack) {
        btnBack.addEventListener('click', function () {
            menuStep.classList.remove('active');
            locationStep.classList.add('active');

            // Reset filter so todas las categorías reaparecen
            resetMenuFilter();

            // Close all accordions when going back
            accordions.forEach(acc => {
                acc.classList.remove('open');
                const content = acc.querySelector('.accordion-content');
                if (content) content.style.maxHeight = null;
            });
        });
    }

    // Accordion Logic
    accordions.forEach(item => {
        const header = item.querySelector('.accordion-header');
        if (!header) return;

        header.addEventListener('click', () => {
            const isOpen = item.classList.contains('open');
            const content = item.querySelector('.accordion-content');

            if (!isOpen) {
                item.classList.add('open');
                content.style.maxHeight = content.scrollHeight + "px";
            } else {
                item.classList.remove('open');
                content.style.maxHeight = null;
            }
        });
    });

    // Dish Modal Logic
    const dishModal = document.querySelector('.js-dish-modal-overlay');
    if (!dishModal) return;

    const modalImg = dishModal.querySelector('.js-dish-modal-img');
    const modalTitle = dishModal.querySelector('.js-dish-modal-title');
    const modalPrice = dishModal.querySelector('.js-dish-modal-price');
    const modalDesc = dishModal.querySelector('.js-dish-modal-desc');

    // Event delegation
    document.addEventListener('click', function (e) {
        const card = e.target.closest('.js-open-dish-modal');
        if (card) {
            e.preventDefault();

            const title = card.querySelector('.dish-title')?.textContent || '';
            const price = card.querySelector('.dish-price')?.textContent || '';
            const desc = card.querySelector('.dish-desc')?.textContent || '';
            const imgEl = card.querySelector('.dish-img');

            if (modalTitle) modalTitle.textContent = title;
            if (modalPrice) modalPrice.textContent = price;
            if (modalDesc) modalDesc.textContent = desc;

            if (imgEl && imgEl.hasAttribute('src') && modalImg) {
                modalImg.src = imgEl.getAttribute('src');
                modalImg.style.display = 'block';
            } else if (modalImg) {
                modalImg.src = '';
                modalImg.style.display = 'none';
            }

            dishModal.classList.add('active');
            document.body.style.overflow = 'hidden';
            return;
        }

        const isCloseBtn = e.target.closest('.js-dish-modal-close');
        const isOverlayBg = e.target.classList.contains('js-dish-modal-overlay');

        if (isCloseBtn || isOverlayBg) {
            dishModal.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
}
